// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "decco/src/Decco.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function requestBody_encode(v) {
  return Js_dict.fromArray([
              [
                "orderId",
                Decco.stringToJson(v.orderId)
              ],
              [
                "actionId",
                Decco.stringToJson(v.actionId)
              ],
              [
                "actionLabel",
                Decco.optionToJson(Decco.stringToJson, v.actionLabel)
              ],
              [
                "amount",
                Decco.optionToJson(Decco.floatToJson, v.amount)
              ],
              [
                "comment",
                Decco.optionToJson(Decco.stringToJson, v.comment)
              ],
              [
                "requestType",
                Decco.optionToJson(Decco.stringToJson, v.requestType)
              ]
            ]);
}

function requestBody_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var orderId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "orderId"), null));
  if (orderId.TAG === /* Ok */0) {
    var actionId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionId"), null));
    if (actionId.TAG === /* Ok */0) {
      var actionLabel = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "actionLabel"), null));
      if (actionLabel.TAG === /* Ok */0) {
        var amount = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "amount"), null));
        if (amount.TAG === /* Ok */0) {
          var comment = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "comment"), null));
          if (comment.TAG === /* Ok */0) {
            var requestType = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "requestType"), null));
            if (requestType.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        orderId: orderId._0,
                        actionId: actionId._0,
                        actionLabel: actionLabel._0,
                        amount: amount._0,
                        comment: comment._0,
                        requestType: requestType._0
                      }
                    };
            }
            var e = requestType._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".requestType" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = comment._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".comment" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = amount._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".amount" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = actionLabel._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".actionLabel" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = actionId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".actionId" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = orderId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".orderId" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function requestBodyList_encode(v) {
  return Decco.listToJson(requestBody_encode, v);
}

function requestBodyList_decode(v) {
  return Decco.listFromJson(requestBody_decode, v);
}

function documentFileType_encode(v) {
  return Js_dict.fromArray([
              [
                "fileType",
                Decco.stringToJson(v.fileType)
              ],
              [
                "fileLabel",
                Decco.stringToJson(v.fileLabel)
              ],
              [
                "mandatory",
                Decco.boolToJson(v.mandatory)
              ]
            ]);
}

function documentFileType_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fileType = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileType"), null));
  if (fileType.TAG === /* Ok */0) {
    var fileLabel = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fileLabel"), null));
    if (fileLabel.TAG === /* Ok */0) {
      var mandatory = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mandatory"), null));
      if (mandatory.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  fileType: fileType._0,
                  fileLabel: fileLabel._0,
                  mandatory: mandatory._0
                }
              };
      }
      var e = mandatory._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".mandatory" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = fileLabel._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".fileLabel" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = fileType._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fileType" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function doccumentFileTypeList_encode(v) {
  return Decco.listToJson(documentFileType_encode, v);
}

function doccumentFileTypeList_decode(v) {
  return Decco.listFromJson(documentFileType_decode, v);
}

var maxAmount = 20000.0;

export {
  maxAmount ,
  requestBody_encode ,
  requestBody_decode ,
  requestBodyList_encode ,
  requestBodyList_decode ,
  documentFileType_encode ,
  documentFileType_decode ,
  doccumentFileTypeList_encode ,
  doccumentFileTypeList_decode ,
}
/* No side effect */
